import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";

//assets

//styles
import typographySizes from "styles/typographySizes.js";
import colors from "styles/colors.js";
import mediaQuery from "styles/mediaQuery.js";
import distances from "styles/distances.js";
//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
import SubTitle from "components/global/typography/heading/SubTitle.js";

//utils
import { getContrastColor } from "utils/colorUtils.js";

const TitleWrapper = styled.div`
grid-area: title;
justify-self: start;
position: relative;
/* padding-top: 3.5rem; */
display: inline-block;
max-width: 100rem;
z-index: 10;

`;

const StyledTitle = styled.h2`
  font-size: ${typographySizes.heading.large.size.desktop}rem;
  line-height: ${typographySizes.heading.large.lineHeight};
  text-transform: uppercase;
  position: relative;

  display: inline; /* będzie się zachowywał jak <span> */


  box-decoration-break: clone;
  color: ${({ backgroundColor }) => getContrastColor(backgroundColor)};
  text-shadow: 0px 0px ${distances.shadow}rem ${({ backgroundColor }) =>
  getContrastColor(backgroundColor)}80;
  width: fit-content; /* Add this to ensure title takes only content width */
  @media (max-width: ${mediaQuery.laptop}) {
    font-size: ${typographySizes.heading.large.size.mobile}rem;
  }
`;

const Intro = ({ subtitle_v1, subtitle_v2, title, color, className }) => {
  const titleRef = useRef(null);
  const [titleWidth, setTitleWidth] = useState(null);

  useEffect(() => {
    const measureTitle = () => {
      if (titleRef.current) {
        const width = titleRef.current.offsetWidth;
        setTitleWidth(width);
      }
    };

    // Initial measurement
    measureTitle();

    // Handle resize
    const handleResize = () => {
      measureTitle();
    };

    window.addEventListener("resize", handleResize);

    // Also measure after fonts load
    document.fonts.ready.then(measureTitle);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [title]); // Re-measure when title changes

  return (
    <TitleWrapper className={className}>
      <SubTitle
        firstLine={subtitle_v1}
        secondLine={subtitle_v2}
        color={color}
        customWidth={titleWidth}
      />
      <StyledTitle ref={titleRef} backgroundColor={color}>
        {/* <span> */}
        <TextWithLineBreaks text={title} />
        {/* </span> */}
      </StyledTitle>
    </TitleWrapper>
  );
};

export default Intro;
